import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { alpha, Box, Container, IconButton, Typography, useTheme } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BusinessProduct } from '../../../../MicrospecDynamicUI/Models/Business/BusinessProduct';
import { useMicrospecThemeLanguageContext } from '../../../../MicrospecDynamicUI/Themes';
import UpsertProduct from './UpsertProduct';

const AddProduct: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { localizationProvider } = useMicrospecThemeLanguageContext();
  const { translate } = localizationProvider;

  const handleSave = (_product: BusinessProduct) => {
    setTimeout(() => { window.location.href = '/manager/products/manage'; }, 2000);
  };

  const handleCancel = () => navigate('/manager/products/manage');

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <IconButton onClick={handleCancel} sx={{ backgroundColor: alpha(theme.palette.primary.main, 0.1), '&:hover': { backgroundColor: alpha(theme.palette.primary.main, 0.2) } }}>
          <ArrowBackIcon />
        </IconButton>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700, color: theme.palette.mode === 'dark' ? theme.palette.grey[100] : theme.palette.grey[900] }}>
            {translate('product.addTitle')}
          </Typography>
          <Typography variant="body2" color="text.secondary">{translate('product.createDescription')}</Typography>
        </Box>
      </Box>
      <UpsertProduct productId={undefined} onSave={handleSave} onCancel={handleCancel} />
    </Container>
  );
};

export default AddProduct;
